export const ListStyles = {
	baseStyle: {
		container: {},
		item: {},
		icon: {},
	},
	sizes: {},
	variants: {},
};
